import SnapMagicViewer from './SnapMagicViewer';

export default SnapMagicViewer;
